import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function usePrescribedNameWithBatches(drugId?: string | null) {
  return useQuery(queries.products.getPrescribedNamesWithBatches(drugId || ''))
}
